<div class="btn-group">
  <button
    [matMenuTriggerFor]="menu"
    class="btn btn-default btn-xs"
    type="button"
    [disabled]="(selectedShapeCount$ | async) === 0"
  >
    <fa-icon [icon]="faLink" [fixedWidth]="true"></fa-icon>
    <span class="caret"></span>
  </button>
  <mat-menu #menu="matMenu" xPosition="before">
    <button
      mat-menu-item
      *ngFor="let groupType of groupTypes"
      (click)="groupShapes(groupType)"
    >
      {{ groupType }}
    </button>
  </mat-menu>
</div>
